import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Particle from "../Particle";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";

gsap.registerPlugin(ScrollTrigger);

function About() {
  useEffect(() => {
    gsap.from(".about-img-inner", {
      scrollTrigger: {
        trigger: ".about-img-inner",
        start: "top 70%",
        toggleActions: "play none none reset",
      },
      x: -60,
      opacity: 0,
      duration: 1,
      ease: "power2.out", // lighter easing
    });

    gsap.from(".about-text-inner", {
      scrollTrigger: {
        trigger: ".about-text-inner",
        start: "top 70%",
        toggleActions: "play none none reset",
      },
      x: 60,
      opacity: 0,
      duration: 1,
      ease: "power2.out",
    });
    gsap.utils.toArray(".tech-icons-wrapper").forEach((icon, i) => {
      gsap.from(icon, {
        scrollTrigger: {
          trigger: icon,
          start: "top 70%",
          toggleActions: "play reverse play reverse",
        },
        scale: 0,
        opacity: 0,
        duration: 0.6,
        delay: i * 0.3,
        ease: "power2.out",
      });
    });

  }, []);


  return (
    <Container fluid className="about-section" style={{ position: "relative" }}>
      <Particle />
      <Container>
        <h1 style={{ paddingBottom: "10px" }}>
          About <strong className="purple">Me</strong>
        </h1>
        <p style={{ color: "#9ca3af", textAlign: "center", marginBottom: "30px", fontSize: "1rem" }}>
          MERN Stack &nbsp;·&nbsp; Angular &nbsp;·&nbsp; WordPress Developer
        </p>
        <Row className="about_container" style={{ justifyContent: "center", padding: "10px" }}>
          <Col md={5} className="about-img-wrapper">
            <div className="about-img-inner">
              <img
                src="https://media.giphy.com/media/qgQUggAC3Pfv687qPC/giphy.gif"
                alt="presenting gif"
                className="img-fluid about-img"
                style={{
                  maxWidth: "100%",
                  height: "auto",
                  objectFit: "cover",
                  borderRadius: "15px",
                }}
              />
            </div>
          </Col>

          <Col md={7} className="about-text-wrapper">
            <div className="about-text-inner">

              <Aboutcard />
            </div>
          </Col>
        </Row>
        <div className="skills-section" style={{ marginTop: "50px" }}>
          <h1 className="project-heading skills-heading">
            Technical <strong className="purple">Proficiency</strong>
          </h1>

          <div className="tech-icons-wrapper">
            <Techstack />
          </div>
        </div>

      </Container>
    </Container>
  );
}

export default About;
